import { toNameConfigMapping } from '../../../configFields';
import { Final } from './Final';

export const Finals = {
  Final,
};

export const finalsList = [Final] as const;

export const finalsMapping = toNameConfigMapping(finalsList);
